import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router';
import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies';
import store from './store';
import req from "@/api/index";

Vue.config.productionTip = false;


/* 组件引入部分 start*/

import contentTitle from '@/components/contentTitle.vue';
Vue.component("contentTitle",contentTitle);

import tinymce from '@/components/tinymce.vue';
Vue.component("tinymce",tinymce);

/* 组件引入部分 end*/


import '@/assets/css/reset.css';
import '@/assets/css/css.css';
import '@/assets/css/iconfont.css';
import 'element-ui/lib/theme-chalk/index.css';
import {
	showLoaing,
	hideLoading,
	customMessage,
} from './util/utils';

import wl from "wl-vue-select";
import "wl-vue-select/lib/wl-vue-select.css";

import print from '@/util/print.js';

Vue.use(print);

Vue.use(wl);
Vue.use(ElementUI);
Vue.use(VueCookies);


Vue.prototype.$message = customMessage;
Vue.prototype.showLoaing = showLoaing;
Vue.prototype.hideLoading = hideLoading;
Vue.prototype.req = req;


router.beforeEach((to, from, next) => { //全局路由守卫

	let loToken = localStorage.getItem('tb_token');
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	if (to.meta.auth) {
		if (loToken) {
			next();
		} else {
			next('/index/login');
		}
	} else {
		next();
	}
	

	
});

new Vue({
	router,
	render: h => h(App),
	store,
	req,
}).$mount('#app')
